import { render } from "./Search.vue?vue&type=template&id=51464ea9"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=51464ea9&lang=css"
script.render = render

export default script